/* src/app/modules_v2/finance/payment-card/components/debit-card-list/debit-card-list.components.css */
.quick-filter {
  display: flex;
  align-items: center;
  gap: 8px;
}
/*# sourceMappingURL=debit-card-list.components.css.map */
